export const CONTEXT_AUTH = "RUTA40-MANAGERAPP-01";
export const CONTEXT_SAVED_EMAIL = "RUTA40-MANAGERAPP-02";
export const CONTEXT_SAVED_PASSWORD = "RUTA40-MANAGERAPP-03";

export const SESSION_SHOW_MODAL = "showModal";
export const SESSION_SHOW_DRAWER = "showDrawer";

export const PASSWORD_REGEXP = /^(?!.*[`~\\%"'<>\s;:,])(?!.*--)(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{}|?/])[A-Za-z\d!@#$%^&*()_\-+=[\]{}|?/]{8,20}$/;

export const FORMAT_DATE = "YYYY-MM-DD";
export const FORMAT_DATE_TIME = "YYYY-MM-DD HH:mm:ss";
export const FORMAT_SIMPLE_DATE = "YY/MM/DD";
export const FORMAT_SIMPLE_DATE_TIME = "YY/MM/DD HH:mm:ss";
export const FORMAT_DATE_KOREAN = "YYYY년 M월 D일";

export const PAGE_WELCOME = "/welcome";
export const PAGE_LOGIN = "/login";
export const PAGE_MAIN = "/main";
export const PAGE_RENT_DETAIL = "/detail";

export const PAGE_USE_CHECKLIST = "/use_checklist";
export const PAGE_USE_ADDIMAGE = "/use_addimage";
export const PAGE_USE_EDUCATION = "/use_education";

export const PAGE_RETURN_BATTERY = "/return_battery";
export const PAGE_RETURN_ADDIMAGE = "/return_addimage";
export const PAGE_RETURN_CHECKLIST = "/return_checklist";
export const PAGE_RETURN_ADD_PAYMENT_ITEM = "/return_addPaymentItem";
export const PAGE_RETURN_ADD_DELAYED_ARRIVE_PAYMENT_ITEM = "/return_addDelayedArrivePaymentItem";
export const PAGE_RETURN_ADD_BATTERY_PAYMENT_ITEM = "/return_addBatteryPaymentItem";
export const PAGE_RETURN_ADD_NORMAL_PAYMENT_ITEM = "/return_addNormalPaymentItem";
export const PAGE_RETURN_RESULT_PAYMENT = "/return_resultPayment";

export const PAGE_DIGITALKEY_CONTROL = "/digitalkey-control";
export const PAGE_DIGITALKEY_LIST = "/digitalkey-list";
export const PAGE_FIND_EV_STATION = "/findEVStation";

export const PAGE_MANUAL = "/manual";

export const PAGE_USE = "/use";
export const PAGE_RETURN = "/return";

export const PAGE_CAR_LOCATION = "/car-location";

export const COLOR_USE = "#9429FF";
export const COLOR_RETURN = "#FFCC00";

export const EVENT_NEXT_PROCESS = "onNextProcessEvent";
export const EVENT_ENABLE_PROCESS_BUTTON = "onEnableProcessButtonEvent";
export const EVENT_SET_HEADER_TITLE = "setHeaderTitle";
export const EVENT_CLOSE_ALL_MODAL = "closeAllModal";
export const EVENT_CLOSE_ALL_DRAWER = "closeAllDrawer";
export const EVENT_BATTERY = "onBatteryEvent";

export const EXTERNAL_EVENT_BACK = "backPressEvent";
export const EXTERNAL_EVENT_RESUME = "resumeAppEvent";

export type TypeLogin = {
    email: string;
    password: string;
};

export const BATTERY_PENALTY = 600;
export const BATTERY_MAX_LIMIT = 100;

export const DEFAULT_USED_TIME = " 14:00:00";
export const DEFAULT_ARRIVED_TIME = " 11:00:00";
